import reportFilename from "../reportFilename";
import buildAcrJsonModel from "./buildAcrJsonModel";

export default function downloadAcrJson(evaluation, catalog) {
  const model = buildAcrJsonModel(evaluation, catalog);
  const jsonString = `${JSON.stringify(model, null, 2)}\n`;
  const blob = new Blob([jsonString], { type: "application/json;charset=utf-8" });
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = `${reportFilename(evaluation)}.json`;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(objectUrl);
}
